import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {HeaderService} from '../../core/services/header.service';
import {AuthService} from '../../core/security/auth.service';
import {merge} from 'rxjs';
import {RolesEnum} from '../../core/security/roles.enum';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {SelectionModel} from '@angular/cdk/collections';
import {ContactsDatasource} from './contacts.datasource';
import {ContactsService as ContactsServiceApiService} from '../../api/services/contacts.service';
import {ContactService} from '../contact.service';
import {ContactModel, ContactsRequest, CustomFieldFilterModel} from '../../api/models';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatCheckbox } from '@angular/material/checkbox';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TagsComponent } from '../../core/visual/tags/tags.component';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';

@Component({
    selector: 'app-contacts-grid',
    templateUrl: './contacts-grid.component.html',
    styleUrls: ['./contacts-grid.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCheckbox,
        MatCellDef,
        MatCell,
        MatSortHeader,
        RouterLink,
        MatIcon,
        MatTooltip,
        TagsComponent,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AsyncPipe,
        PhoneNumberPipe,
    ],
})
export class ContactsGridComponent implements OnDestroy, OnInit, AfterViewInit, OnChanges {
  allColumns: string[] = ['select', 'firstName', 'phoneNumber', 'mobileNumber', 'faxNumber', 'email', 'companyName', 'position', 'recordType', 'tags'];
  displayedColumns: string[] = ['select', 'firstName', 'phoneNumber', 'mobileNumber', 'faxNumber', 'email', 'companyName', 'position', 'recordType', 'tags'];
  @Input() filterChangeEvent: EventEmitter<any>;
  @Input() showAdditionalColumns = false;
  @Input() readonly = false;
  hasSupportAccess = false;
  additionalFilter: any = {};
  recIdFilter: string;
  isLoading = true;
  searchText: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: ContactsDatasource;
  selectedRows: SelectionModel<ContactModel>;
  detailsUrl: string;

  constructor(public contactService: ContactService,
              public dialog: MatDialog,
              private contactsApiService: ContactsServiceApiService,
              public headerService: HeaderService, public authService: AuthService) {
  }

  ngOnInit() {
    this.hasSupportAccess = this.authService.hasAccess([RolesEnum.Support]);
    this.dataSource = new ContactsDatasource(this.contactsApiService);

    this.detailsUrl = '../contact';

    const initialSelection = [];
    const allowMultiSelect = true;
    this.selectedRows = new SelectionModel<ContactModel>(allowMultiSelect, initialSelection);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['readonly'] && changes['readonly'].currentValue) {
      this.displayedColumns = this.allColumns.filter(x => x != 'select');
    } else {
      this.displayedColumns = [...this.allColumns];
    }
  }

  ngAfterViewInit() {
    this.filterChangeEvent?.subscribe((filter) => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
    });

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();
  }

  loadData() {
    console.log('filter changed');
    this.selectedRows.clear();
    this.dataSource.queryData(this.getDataFilter());
  }

  getDataFilter(): ContactsRequest {
    return {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
      searchText: this.additionalFilter?.searchText,
      firstName: this.additionalFilter?.firstName,
      lastName: this.additionalFilter?.lastName,
      mobileNumber: this.additionalFilter?.mobileNumber,
      phoneNumber: this.additionalFilter?.phoneNumber,
      faxNumber: this.additionalFilter?.faxNumber,
      companyName: this.additionalFilter?.companyName,
      position: this.additionalFilter?.position,
      contactType: this.additionalFilter?.contactType,
      email: this.additionalFilter?.email,
      tags: this.additionalFilter?.tags,
      speedDial: this.additionalFilter?.speedDial,
      customFields: this.formatCustomFields(this.additionalFilter),
    };
  }

  ngOnDestroy() {
  }

  isAllSelected() {
    const numSelected = this.selectedRows.selected.length;
    const numRows = this.dataSource.currentPageData().length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selectedRows.clear() :
      this.dataSource.currentPageData().forEach(row => this.selectedRows.select(row));
  }

  private formatCustomFields(additionalFilter?: any): Array<CustomFieldFilterModel> {
    if (!additionalFilter) {
      return [];
    }

    const result: Array<CustomFieldFilterModel> = [];
    for (const key of Object.keys(additionalFilter)) {
      if (key.startsWith('customField.') && additionalFilter[key].value !== '') {
        const operator = key.split('.')[1];
        const filterKey = key.replace(`customField.${operator}.`, '');
        result.push(
          {
            fieldKey: filterKey,
            value: additionalFilter[key],
            operator: operator,
          }
        )
      }
    }
    return result;
  }
}
